module.exports = __webpack_public_path__ + "img/VIOR-alt.78f74180.svg";